<template lang="pug">
.container
    nav.nav
        router-link.button__action(
            to="/markets/"
            active-class="null"
        )
            i.glyphicon.glyphicon-chevron-left.icon
            | Go back
        .submit__container
            button.button__submit(
                type="button"
                @click="save()"
            ) Save
    header
        h2.title {{getActiveMarket.title}}
        div
            img(
                :src="getFlagUrl(getActiveMarket)"
            )
    .editing__container
        vue-tabs(
            activeTextColor="#09a3ed"
            v-if="getActiveMarket"
        )
            v-tab(
                title="General Settings"
            )
                .inner-tab
                    div.top-details
                        .form__control-group
                            label Market
                            input(
                                class="input__text title"
                                type="text"
                                v-model="getActiveMarket.title"
                            )
                        div
                            .form__control-group
                                label Locale
                                input(
                                    disabled
                                    class="input__text title"
                                    type="text"
                                    v-model="getActiveMarket.locale"
                                )
                            .form__control-group
                                label Country
                                input(
                                    disabled
                                    class="input__text title"
                                    type="text"
                                    v-model="getActiveMarket.country"
                                )
                            .form__control-group
                                label Language
                                input(
                                    disabled
                                    class="input__text title"
                                    type="text"
                                    v-model="getActiveMarket.primaryLanguage"
                                )
                            p Note: Countries and languages for markets are not editable.
            v-tab(
                title="App Activity Phrases"
            )
                .inner-tab
                    div(
                        v-if="!getActiveMarket.hasPhrases"
                    )
                        p No activity phrases found for this market.
                        .button-container
                            button.button__action(
                                @click="createBlankActivityPhrases"
                            ) Create activity phrases from scratch
                            button.button__action(
                                @click="copyActivityPhrases"
                            ) Copy activity phrases from an existing market
                            .copy-phrases(
                                v-if="showMarketChoices"
                            )
                                select(
                                    v-model="copyFromMarket"
                                )
                                    option(
                                        v-if="market.locale != getActiveMarket.locale"
                                        :value="market.locale"
                                        v-for="market in getMarkets"
                                    ) {{ market.title}}
                                button.button__action(
                                    @click="createCopiedPhrases"
                                ) Copy
                    div.form(
                        v-if="getActiveMarket.hasPhrases"
                    )
                        .form__control-group
                            label Enrollment
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.enrollment"
                            )
                        .form__control-group
                            label Completed Enrollment
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.completed_enrollment"
                            )
                        .form__control-group
                            label Added Contact
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.added_contact"
                            )
                        .form__control-group
                            label Media Followed Up
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.media_followed_up"
                            )
                        .form__control-group
                            label Low Interest Follow Up
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.low_interest_follow_up"
                            )
                        .form__control-group
                            label Default Follow Up
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.default_follow_up"
                            )
                        .form__control-group
                            label Shared Cart
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.shared_cart"
                            )
                        .form__control-group
                            label Purchased Cart
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.purchased_cart"
                            )
                        .form__control-group
                            label Shipped Cart
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.shipped_cart"
                            )
                        .form__control-group
                            label Scheduled Meeting With Title
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.scheduled_meeting_with_title"
                            )
                        .form__control-group
                            label Blank Meeting
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.blank_meeting"
                            )
                        .form__control-group
                            label Future Meeting
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.future_meeting"
                            )
                        .form__control-group
                            label Sent Message
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.sent_message"
                            )
                        .form__control-group
                            label Sent Email
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.sent_email"
                            )
                        .form__control-group
                            label Meeting Invite
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.meeting_invite"
                            )
                        .form__control-group
                            label Shared Media
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.shared_media"
                            )
                        .form__control-group
                            label Shared Multiple Media
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.shared_multiple_media"
                            )
                        .form__control-group
                            label Received Message
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.received_message"
                            )
                        .form__control-group
                            label Contact Assigned
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.contact_assigned"
                            )
                        .form__control-group
                            label Contact Updated
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.contact_updated"
                            )
                        .form__control-group
                            label Failed Subscriptions
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.failed_subscriptions"
                            )
                        .form__control-group
                            label Failed Subscriptions Follow Up
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.failed_subscriptions_followup"
                            )
                        .form__control-group
                            label Product Upsell
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.product_upsell"
                            )
                        .form__control-group
                            label Default
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.default"
                            )
                        .form__control-group
                            label GDPR Text
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.gdprtext"
                            )
                        .form__control-group
                            label GDPR SMS Text
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.gdprsmstext"
                            )
                        .form__control-group
                            label Message Signature
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.msgsignature"
                            )
                        .form__control-group
                            label Thank you
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.activityPhrases.thankyou"
                            )
            v-tab(
                title="Volume Links"
            )
                .inner-tab
                    div.volume-link-header
                        h3 Volume Links
                        button.button__action.copy-button(
                            @click="toggleCopyVolumeLinks"
                        ) Copy from Other Market
                    p(
                        v-if="!getActiveMarket.volumeLinks"
                    ) There are no volume links associated with this market.
                div.form(
                        v-if="getActiveMarket.volumeLinks"
                    )
                        .form__control-group(
                            v-for="(link, name, index) in getActiveMarket.volumeLinks.content"
                        )
                            h4 {{ getActiveMarket.volumeLinks.content[name].label }}
                            label Title
                            input.input__text.title.volume-title(
                                type="text"
                                v-model="getActiveMarket.volumeLinks.content[name].title"
                                placeholder="Title"
                            )
                            label URL
                            input.input__text.title(
                                type="text"
                                v-model="getActiveMarket.volumeLinks.content[name].url"
                                placeholder="URL"
                            )
            v-tab(
                title="Action Cards"
            )
                .inner-tab
                     div
                        h3 Action Cards
                        p(
                            v-if="!getActiveMarket.cards || !getActiveMarket.cards.length"
                        ) There are no Action Cards associated with this market.
                        div.card-grid
                            router-link(
                                :key="`card-${index}`"
                                v-for="(card, index) in getActiveMarket.cards"
                                :to="'/cards/'+card._id"
                                class="card-wrap"
                            )
                                LibraryActionCard(
                                    :slug="card.legacyName ? card.legacyName : ''"
                                    :cardTitle="card.displayName === 'Training Media' ? (card.mediaId ? card.mediaId.title : '') : card.displayName"
                                    :media="card.mediaId ? card.mediaId : null"
                                    :title="card.title ? card.title.intial : null"
                                    :callToAction="card.callToAction ? card.callToAction.intial : ''"
                                )
            v-tab(
                title="Media"
            )
                .inner-tab
                    h3 Media
                    p(
                        v-if="!getActiveMarket.mediaRecords || !getActiveMarket.mediaRecords.length"
                    ) There are no media items associated with this market.
                    div.media-items-list
                        router-link(
                            :key="`media-${index}`"
                            v-for="(media, index) in getActiveMarket.mediaRecords"
                            :to="`/media/${media._id}`"
                        )
                            img(
                                :src="media.thumbnail"
                            )
            v-tab(
                title="Product Groups"
            )
                div.inner-tab
                    h3 Product Groups
                    p(
                        v-if="!getActiveMarket.productGroups || !getActiveMarket.productGroups.length"
                    ) There are no product groups associated with this market.
                    div.product-group-list
                        router-link.product-group__link(
                            :key="`${productGroup._id}`"
                            v-for="productGroup in getActiveMarket.productGroups"
                            :to="`/product-groups/${productGroup._id}`"
                        )
                            .product.box
                                h3 {{productGroup.title}}
            v-tab(
                title="Products"
            )
                div.inner-tab
                    h3 Products
                        button.button__action(
                            v-if="!showProducts && getActiveMarket.products && getActiveMarket.products.length"
                            @click="toggleProducts"
                        ) Show
                        button.button__action(
                            v-if="showProducts && getActiveMarket.products && getActiveMarket.products.length"
                            @click="toggleProducts"
                        ) Hide
                    p(
                        v-if="!getActiveMarket.products ||  !getActiveMarket.products.length"
                    ) There are no products associated with this market.
                    div.products(
                        v-if="showProducts"
                    )
                        router-link.product__link(
                            :key="`${product._id}`"
                            v-for="product in getActiveMarket.products"
                            :to="`/products/${product._id}`"
                        )
                            .product.box
                                .image__container
                                    img(
                                        v-if="product.defaultImage"
                                        :src="product.defaultImage"
                                    )
                                    img(
                                        v-if="!product.defaultImage"
                                        src="/static/images/product-placeholder.png"
                                    )
                                h3 {{product.name}}

</template>
<script>
import store from '../../store';
import VueNotifications from 'vue-notifications';
import Services from '../../services/Services';
import LibraryActionCard from '../general/LibraryActionCard';
import { VueTabs, VTab } from 'vue-nav-tabs';
import 'vue-nav-tabs/themes/paper.css';
import MediaCard from '../general/MediaCard';
import Multiselect from 'vue-multiselect';
import Spinner from '../general/Spinner';
import { postResource } from '../../services/Utils';
import moment from 'moment';
export default {
  name: 'MarketEditor',
  components: {
    LibraryActionCard,
    MediaCard,
    Multiselect,
    VueTabs,
    VTab
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data() {
    return {
      showCards: false,
      showMarketChoices: false,
      copyFromMarket: '',
      showMedia: false,
      showProductGroups: false,
      showProducts: false,
      getFlagUrl: Services.getFlagUrl,
      marketLoaded: false
    };
  },
  computed: {
    getActiveMarket: {
      get: function() {
        return store.getters.getActiveMarket;
      },
      set: function(market) {
        store.commit('setActiveMarket', market);
      }
    },
    getMarkets() {
      return store.getters.getMarkets;
    }
  },
  methods: {
    toggleCards() {
      this.showCards = !this.showCards;
    },
    toggleCopyVolumeLinks(){
        store.commit('showCopyVolumeLinksModal', true);
    },
    toggleMedia() {
      this.showMedia = !this.showMedia;
    },
    toggleProductGroups() {
      this.showProductGroups = !this.showProductGroups;
    },
    toggleProducts() {
      this.showProducts = !this.showProducts;
    },
    createBlankActivityPhrases() {
      const newRecord = {
        locale: this.getActiveMarket.locale.toLowerCase(),
        content: {
          enrollment: '',
          completed_enrollment: '',
          added_contact: '',
          media_followed_up: '',
          low_interest_follow_up: '',
          default_follow_up: '',
          shared_cart: '',
          purchased_cart: '',
          shipped_cart: '',
          scheduled_meeting_with_title: '',
          blank_meeting: '',
          future_meeting: '',
          sent_message: '',
          sent_email: '',
          meeting_invite: '',
          shared_media: '',
          shared_multiple_media: '',
          received_message: '',
          contact_assigned: '',
          contact_updated: '',
          failed_subscriptions: '',
          failed_subscriptions_followup: '',
          product_upsell: '',
          default: '',
          gdprtext: '',
          gdprsmstext: '',
          msgsignature: '',
          thankyou: ''
        }
      };

      postResource(
        '/v1/markets/addActivityPhrases',
        `id=${this.getActiveMarket._id}`,
        newRecord
      )
        .then(() => {
          this.showSuccessMsg({
            message: `${this.getActiveMarket.title} activity phrases saved!`
          });
        })
        .then(() => {
          const marketId = this.$route.params.marketId;

          Services.setActiveMarket(marketId);
        })
        .catch(error => {
          this.showErrorMsg({
            message: `There was an error. Please try again.`
          });
        });
    },
    copyActivityPhrases() {
      this.showMarketChoices = true;
    },
    createCopiedPhrases() {
      if (this.copyActivityPhrases) {
        const update = {
          locale: this.getActiveMarket.locale,
          targetLocale: this.copyFromMarket
        };
        postResource(
          '/v1/markets/copyActivityPhrases',
          `id=${this.getActiveMarket._id}`,
          update
        )
          .then(() => {
            this.showSuccessMsg({
              message: `${this.getActiveMarket.title} activity phrases copied and saved!`
            });
          })
          .then(() => {
            const marketId = this.$route.params.marketId;

            Services.setActiveMarket(marketId);
          })
          .catch(error => {
            this.showErrorMsg({
              message: `There was an error. Please try again.`
            });
          });
      } else {
        this.showErrorMsg({
          message: `Please select a market to copy from.`
        });
      }
    },
    save() {
      const update = {
        title: this.getActiveMarket.title,
        activityPhrases: this.getActiveMarket.activityPhrases,
        volumeLinks: this.getActiveMarket.volumeLinks.content
      };

      console.log('update', update);

      postResource(
        '/v1/markets/update',
        `id=${this.getActiveMarket._id}`,
        update
      )
        .then(() => {
          this.showSuccessMsg({
            message: `${this.getActiveMarket.title} market saved!`
          });
        })
        .catch(error => {
          this.showSuccessMsg({
            message: `There was an error. Please try again.`
          });
        });
    }
  },
  mounted() {
    const marketId = this.$route.params.marketId;

    if (!marketId) {
      this.showErrorMsg({ message: 'No matching market found' });
      this.$router.push('/markets/');
    }

    Services.setActiveMarket(marketId);
  },
  beforeDestroy() {
    Services.clearActiveProduct();
    Services.clearActiveMarket();
    Services.clearActiveRecords();
  }
};
</script>
<style lang="scss" scoped>
header {
  display: flex;
  //   height: 100px;
  align-items: center;
  margin-top: 4.375rem;
  padding: 0 2rem;
  margin-bottom: 0;

  img {
    display: block;
    height: auto;
    margin-left: 1rem;
  }
}
.button__submit {
  padding: 8px 32px;
  width: auto;
  margin-left: 25px;
}

.editing__container {
  display: flex;
  padding: 2rem;
  flex-wrap: no-wrap;
  width: 100%;

  .form__control-group {
    margin-bottom: 1rem;
  }

  input,
  textarea {
    width: 100%;

    &.title {
      max-width: 630px;
    }
  }

  .image__container,
  .meta__container {
    width: 33.33%;

    .button__action {
      margin: 1rem 0;
    }
  }

  .image__container {
    display: block;

    img {
      margin: auto;
    }
  }

  .content__container {
    width: 100%;

    h1 img {
      position: relative;
      top: 15px;
      margin-left: 1rem;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
      padding: 0 10px;
    }
  }

  .content__container,
  .meta__container {
    padding-left: 2.6rem;
  }

  @media all and (max-width: 640px) {
    flex-direction: column;

    .image__container,
    .content__container,
    .meta__container {
      padding-left: 0;
      width: 100%;
    }
  }
}

.top-details {
  display: flex;

  @media all and (max-width: 640px) {
    flex-direction: column;
  }

  > div {
    padding: 0 1.6rem;
    width: 50%;

    &:first-child {
      padding-left: 0;
    }

    @media all and (max-width: 640px) {
      padding: 0;
      width: 100%;
    }
  }
}

h3 {
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 2rem;
}

.form__control-group {
  label {
    display: block;
    margin-bottom: 5px;
  }
}

.card-grid {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  left: -10px;
}

.button__action {
  display: inline-block;
}

.media__container,
.product__container {
  padding-left: 4.7rem;
  margin-bottom: 2rem;
  width: 100%;
}

.media-items-list {
  display: flex;
  position: relative;
  left: -1rem;
  flex-wrap: wrap;

  img {
    cursor: pointer;
    max-width: 200px;
    margin: 1rem;
  }
}

input:disabled {
  background: #eee;
}

.product-group-list {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  left: -2rem;
  .product-group__link {
    padding: 0 2rem 2%;
    text-decoration: none;
    max-width: 460px;
    min-width: 300px;
    width: 25%;

    @media all and(max-width:640px) {
      width: 100%;
    }
  }
  .box {
    margin: auto;
    border: 1px dashed #ccc;
    color: #666;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    &.product {
      border-style: solid;
      flex-direction: column;
      text-transform: capitalize;
      text-align: center;
      padding: 1.6rem;
      align-items: flex-end;
      text-decoration: none;
      width: 100%;

      h3 {
        width: 100%;
      }

      .image__container {
        overflow: hidden;
      }

      img {
        margin: auto;
        max-width: 100%;
      }
    }

    &:hover {
      border-color: rgb(1, 168, 220);
      color: #073262;
      cursor: pointer;
    }
  }
}

.products {
  display: flex;
  flex-wrap: wrap;
  .product__link {
    padding: 0 2rem 2%;
    text-decoration: none;
    max-width: 460px;
    min-width: 300px;
    width: 25%;

    @media all and(max-width:640px) {
      width: 100%;
    }

    &:first-child {
      padding-left: 0;
    }
  }
  .box {
    margin: auto;
    border: 1px dashed #cecece;
    color: #666;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    &.product {
      border-style: solid;
      flex-direction: column;
      text-transform: capitalize;
      text-align: center;
      padding: 1.6rem;
      align-items: flex-end;
      text-decoration: none;
      width: 100%;

      h3 {
        width: 100%;
      }

      .image__container {
        margin: auto;
        overflow: hidden;
      }

      img {
        display: block;
        margin: auto;
        max-width: 100%;
      }
    }

    &:hover {
      border-color: rgb(1, 168, 220);
      color: #073262;
      cursor: pointer;
    }
  }
}
.copy-phrases {
  margin-left: 10px;
  margin-top: 1rem;
}

.volume-title {
    margin-bottom: 10px;
}

h4 {
    font-size: 1.1rem;
    margin-bottom: 5px;
}

.volume-link-header {
    display: flex;
    flex-direction: row;

    .copy-button {
        position: relative;
        top: 7px;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/views/MarketEditor.vue